import React, { useEffect, useState } from "react";
import Content from "../../layout/content/Content";
import Head from "../../layout/head/Head";
import {
    BlockBetween,
    Block,
    BlockHeadContent,
    BlockHead,
    BlockTitle,
    Icon,
    Button,
  DataTableRow,
  DataTableBody,
  DataTableHead,
  DataTableItem,
  PaginationComponent,
  DataTable,
} from "../../components/Component";
import {
    DropdownMenu,
    DropdownToggle,
    UncontrolledDropdown,
    DropdownItem,
  } from "reactstrap";
import FormModal from "./FormModal";
import { handleDeleteApis, handleGetApis } from "../../service/Api";

const ViewBanner = () => {
  
  useEffect(() => {
        fetchData();
}, [])
  const [sm, updateSm] = useState(false);
  const [modal, setModal] = useState({
    edit: false,
    add: false,
  });
  const [currentPage, setCurrentPage] = useState(1);
    const [itemPerPage] = useState(7);
    const [offerDdata, setOfferData] = useState([])

    const fetchData = () => {
      
      handleGetApis('admin/get/banner')
        .then(result => {
          console.log(result)
          if (result) {
            setOfferData(result.data.data);
          }
        })
        .catch(error => {
          console.error('Error fetching data:', error);
        });
    };
    const [formData, setFormData] = useState({
      image: "",
      mobile_image: "",
      title: "",
      description: "",
      button_text: "",
      button_link: "",
      position : null,
      is_active : null
    });
    const [editFormData, setEditFormData] = useState({
      id: "",
      image: "",
      mobile_image: "",
      title: "",
      description: "",
      button_text: "",
      button_link: "",
      position : null,
      is_active : null
    });
  
    // Delete TravelDeals
  const deleteOffer = (id) => {

    const res = handleDeleteApis(`admin/delete/banner`, {id})
    res.then(function (result) {
      if (result) {
        alert(result.data.message)
        setOfferData((prevData) => prevData.filter((item) => item.id !== id));
      }
    })
  }
  const handleDelete = (id) => {
    if (window.confirm("are you sure want to delete banner")) {
      deleteOffer(id);
    }
  }
   // function to reset the form
   const resetForm = () => {
    setFormData({
      image: "",
      mobile_image: "",
      title: "",
      description: "",
      button_text: "",
      button_link: "",
      position : null,
      is_active : null
    });
  };

  const closeModal = () => {
    setModal({ add: false })
    resetForm();
  };

  const closeEditModal = () => {
    setModal({ edit: false })
    resetForm();
  };
  // submit function to update a new item
  const onEditClick = (id) => {
    if (offerDdata && offerDdata) {
      offerDdata.forEach((item) => {
        if (item.id === id) {
          setEditFormData({
            id: item.id,
            is_active : item.is_active,
            title : item.title,
            description : item.description,
            position : item.position,
            image : item.image,
            mobile_image : item.mobile_image || "",
            button_link : item.button_link,
            button_text : item.button_text,
          });
          setModal({ edit: true }, { add: false });
        }
      });
    }
  };  
  const indexOfLastItem = currentPage * itemPerPage;
  const indexOfFirstItem = indexOfLastItem - itemPerPage;
  const currentItems = offerDdata && offerDdata.slice(indexOfFirstItem, indexOfLastItem);
  console.log(currentItems)
  // Change Page
  const paginate = (pageNumber) => setCurrentPage(pageNumber);
    return (
        <>
        
          <Head title="Home Banner"></Head>
             <Content>
               <BlockHead size="sm">
                 <BlockBetween>
                   <BlockHeadContent>
                     <BlockTitle page>Home Banner</BlockTitle>
                   </BlockHeadContent>
                   <BlockHeadContent>
                     <div className="toggle-wrap nk-block-tools-toggle">
                       <Button
                         className={`btn-icon btn-trigger toggle-expand me-n1 ${sm ? "active" : ""}`}
                         onClick={() => updateSm(!sm)}
                       >
                         <Icon name="menu-alt-r"></Icon>
                       </Button>
                       <div className="toggle-expand-content" style={{ display: sm ? "block" : "none" }}>
                         <ul className="nk-block-tools g-3">
                          
                           <li className="nk-block-tools-opt" onClick={() => setModal({ add: true })}>
                             <Button color="primary">
                               <Icon name="plus"></Icon>
                               <span>Add Home Banner</span>
                             </Button>
                           </li>
                         </ul>
                       </div>
                     </div>
                   </BlockHeadContent>
                 </BlockBetween>
               </BlockHead>
               <Block>
                 <DataTable className="card-stretch">
                   <DataTableBody>
                     <DataTableHead className="nk-tb-item nk-tb-head">
                       <DataTableRow>
                         <span className="sub-text">Title</span>
                       </DataTableRow>
                       <DataTableRow size='md'>
                         <span className="sub-text">Button Text</span>
                       </DataTableRow>
                       <DataTableRow size='md'>
                         <span className="sub-text">Button Link</span>
                       </DataTableRow>
                        <DataTableRow size='sm'>
                         <span className="sub-text">Status</span>
                       </DataTableRow>
                       <DataTableRow className="nk-tb-col-tools text-end">
                         <span className="sub-text">Action</span>
                       </DataTableRow>
                     </DataTableHead>
                     {currentItems?.length > 0
                       ? currentItems.map((item) => {
                         return (
                           <DataTableItem key={item.id}>
                             <DataTableRow>
                               <li style={{listStyle : "none"}}>{item.title}</li>
                             </DataTableRow>
                                 <DataTableRow size='md'>
                             <li style={{listStyle : "none"}}>{item.button_text}</li>
                                 </DataTableRow>
                                 <DataTableRow size='md'>
                             <li style={{listStyle : "none"}}>{item.button_link}</li>
                                 </DataTableRow>
                                 <DataTableRow size='sm'>
                             <li style={{listStyle : "none",color : item.is_active === 1 ? "green" : "red"}}>{item.is_active === 1 ? 'Active' : "Non Active"}</li>
                             </DataTableRow>
                               <DataTableRow className="nk-tb-col-tools text-end">
                                 <ul className="nk-tb-actions gx-1">
                                   <li>
                                     <UncontrolledDropdown>
                                       <DropdownToggle tag="a" className="text-soft dropdown-toggle btn btn-icon btn-trigger">
                                         <Icon name="more-h"></Icon>
                                       </DropdownToggle>
                                       <DropdownMenu end>
                                         <ul className="link-list-opt no-bdr">
                                           <li onClick={()=>{onEditClick(item.id)}}>
                                             <DropdownItem
                                               tag="a"
                                               href="#edit"
                                               onClick={(ev) => {
                                                 ev.preventDefault();
                                               }}
                                             >
                                               <Icon name="edit"></Icon>
                                               <span>Edit</span>
                                             </DropdownItem>
                                           </li>
                                             <li onClick={()=>{handleDelete(item.id)}}>
                                               <DropdownItem
                                                 tag="a"
                                                 href="#markasdone"
                                                 onClick={(ev) => {
                                                   ev.preventDefault();
                                                 }}
                                               >
                                                 <Icon name="trash"></Icon>
                                                 <span>Delete</span>
                                               </DropdownItem>
                                             </li>
                                         </ul>
                                       </DropdownMenu>
                                     </UncontrolledDropdown>
                                   </li>
                                 </ul>
                               </DataTableRow>
                           </DataTableItem>
                           );
                         })
                       : null}
                   </DataTableBody>
                   <div className="card-inner">
                     {offerDdata?.length > 0 ? (
                       <PaginationComponent
                         itemPerPage={itemPerPage}
                         totalItems={offerDdata?.length}
                         paginate={paginate}
                         currentPage={currentPage}
                       />
                     ) : (
                       <div className="text-center">
                         <span className="text-silent">No data found</span>
                       </div>
                     )}
                   </div>
                 </DataTable>
               </Block>
               
               <FormModal modal={modal.add} modalType="add" formData={formData} setFormData={setFormData} closeModal={closeModal} fetchData={fetchData}/>
               <FormModal modal={modal.edit} modalType="edit" formData={editFormData} setFormData={setEditFormData} closeModal={closeEditModal} fetchData={fetchData}/>
             </Content>
        </>
    
  );
};

export default ViewBanner;
